var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_132231)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3172_132231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 16C28.1 22.6826 22.6826 28.1 16 28.1C9.31735 28.1 3.9 22.6826 3.9 16C3.9 9.31735 9.31735 3.9 16 3.9C22.6826 3.9 28.1 9.31735 28.1 16Z",
    stroke: "#6A66D9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.875 8.95078C20.875 9.57328 20.3725 10.0758 19.75 10.0758C19.1275 10.0758 18.625 9.57328 18.625 8.95078C18.625 8.20078 19.75 6.92578 19.75 6.92578C19.75 6.92578 20.875 8.20078 20.875 8.95078ZM17.125 8.95078C17.125 9.57328 16.6225 10.0758 16 10.0758C15.3775 10.0758 14.875 9.57328 14.875 8.95078C14.875 8.20078 16 6.92578 16 6.92578C16 6.92578 17.125 8.20078 17.125 8.95078ZM13.375 8.95078C13.375 9.57328 12.8725 10.0758 12.25 10.0758C11.6275 10.0758 11.125 9.57328 11.125 8.95078C11.125 8.20078 12.25 6.92578 12.25 6.92578C12.25 6.92578 13.375 8.20078 13.375 8.95078ZM11.3333 10.7509C10.597 10.7509 10 11.4224 10 12.2509V14.5009H9.25C8.83579 14.5009 8.5 14.8366 8.5 15.2509V16.7509C8.5 17.1651 8.83579 17.5009 9.25 17.5009H10V22.0009V22.7509V23.5009V24.2509C10 24.6651 10.3358 25.0009 10.75 25.0009H11.5C11.9142 25.0009 12.25 24.6651 12.25 24.2509V23.5009H19.75V24.2509C19.75 24.6651 20.0858 25.0009 20.5 25.0009H21.25C21.6642 25.0009 22 24.6651 22 24.2509V23.5009V22.7509V22.0009V17.5009H22.75C23.1642 17.5009 23.5 17.1651 23.5 16.7509V15.2509C23.5 14.8366 23.1642 14.5009 22.75 14.5009H22V12.2509C22 11.4224 21.403 10.7509 20.6667 10.7509H11.3333ZM21.25 14.1259V18.2509H10.75V14.1259H21.25ZM12.25 21.2509C12.6642 21.2509 13 20.9151 13 20.5009C13 20.0866 12.6642 19.7509 12.25 19.7509C11.8358 19.7509 11.5 20.0866 11.5 20.5009C11.5 20.9151 11.8358 21.2509 12.25 21.2509ZM20.5 20.5009C20.5 20.9151 20.1642 21.2509 19.75 21.2509C19.3358 21.2509 19 20.9151 19 20.5009C19 20.0866 19.3358 19.7509 19.75 19.7509C20.1642 19.7509 20.5 20.0866 20.5 20.5009ZM18.25 20.8759V20.1259H13.75V20.8759H18.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3172_132231",
    x: -1,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3172_132231"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3172_132231",
    result: "effect2_dropShadow_3172_132231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3172_132231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_132231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/43f5c4b2cf644d6e9b2b63f8a121920c0e86ff68f0.svg";
export { ForwardRef as ReactComponent };